/* ─────────────────────────────────────────────────────────────────────────
   Vinanest — collection filtering & sorting (client-side, progressive).
   Filters the cards already rendered by vinanest-collection.liquid:
   • type chips (built from each card's data-type)
   • in-stock toggle (data-avail)
   • sort: featured (original order) / price / name
   Labels use the shared [data-i18n] dictionary in vinanest-landing.js,
   so language switching is handled automatically by applyLang().
   ───────────────────────────────────────────────────────────────────────── */
(function(){
  function init(){
    var bar = document.getElementById("collFilters");
    var grid = document.querySelector(".prod-grid");
    if(!bar || !grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".card"));
    if(!cards.length) return;            /* nothing to filter */

    var original = cards.slice();        /* snapshot for "featured" order */
    var chipsBox = document.getElementById("collChips");
    var sortSel  = document.getElementById("collSort");
    var stockBox = document.getElementById("collStock");
    var countEl  = document.getElementById("collCount");

    /* ---- build type chips from the products actually present ---- */
    var types = [];
    cards.forEach(function(c){
      var t = (c.getAttribute("data-type")||"").trim();
      if(t && types.indexOf(t) === -1) types.push(t);
    });
    if(types.length >= 2 && chipsBox){
      types.forEach(function(t){
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cfl-chip";
        b.setAttribute("data-type", t);
        b.textContent = t;
        chipsBox.appendChild(b);
      });
    } else if(chipsBox){
      chipsBox.style.display = "none";   /* 0–1 types: chips add no value */
    }

    var activeType = "*";

    function apply(){
      var inStockOnly = stockBox && stockBox.checked;
      var sort = sortSel ? sortSel.value : "featured";

      /* order */
      var ordered;
      if(sort === "price-asc"){
        ordered = original.slice().sort(function(a,b){ return (+a.getAttribute("data-price")||0) - (+b.getAttribute("data-price")||0); });
      } else if(sort === "price-desc"){
        ordered = original.slice().sort(function(a,b){ return (+b.getAttribute("data-price")||0) - (+a.getAttribute("data-price")||0); });
      } else if(sort === "name"){
        ordered = original.slice().sort(function(a,b){ return (a.getAttribute("data-title")||"").localeCompare(b.getAttribute("data-title")||""); });
      } else {
        ordered = original.slice();
      }
      ordered.forEach(function(c){ grid.appendChild(c); });   /* re-flow DOM */

      /* visibility + count */
      var shown = 0;
      ordered.forEach(function(c){
        var t = (c.getAttribute("data-type")||"").trim();
        var avail = c.getAttribute("data-avail") === "1";
        var ok = (activeType === "*" || t === activeType) && (!inStockOnly || avail);
        c.style.display = ok ? "" : "none";
        if(ok){ shown++; c.classList.add("in"); }   /* keep reveal-animated cards visible */
      });
      if(countEl) countEl.textContent = shown;
    }

    /* ---- wire controls ---- */
    if(chipsBox){
      chipsBox.addEventListener("click", function(e){
        var btn = e.target.closest(".cfl-chip"); if(!btn) return;
        activeType = btn.getAttribute("data-type") || "*";
        chipsBox.querySelectorAll(".cfl-chip").forEach(function(x){ x.classList.toggle("on", x === btn); });
        apply();
      });
    }
    if(sortSel)  sortSel.addEventListener("change", apply);
    if(stockBox) stockBox.addEventListener("change", apply);

    /* master Subscribe & Save toggle — flips every card with selling plans into sub / once mode */
    var subBox=document.getElementById("collSub");
    if(subBox) subBox.addEventListener("change", function(){
      var mode = subBox.checked ? "sub" : "once";
      grid.querySelectorAll(".card-buy").forEach(function(box){
        var b=box.querySelector('.po-row[data-mode="'+mode+'"]');     /* only cards with selling plans have .po-row */
        if(b && typeof window.cardPO==="function") window.cardPO(b, mode);
      });
    });

    bar.hidden = false;     /* progressive enhancement: reveal only once wired */
    bar.classList.add("in");/* ensure visible (it was display:none while .reveal observed) */
    apply();
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
